<template>
<div id="catalogo_mt" >
    <v-power-catalogo :parametros="parametros" />
</div>
</template>

<script>
import powerCatalogo from "@/views/apendices/layout.vue";
export default {
    components: {
        "v-power-catalogo": powerCatalogo
    },
    created() {
        window.getApp.$emit("APP_DRAWER_HIDE");
    },

    data: () => ({
        fab: false,
        parametros: {
            url_actions: "apendices/",
            url_list: "apendices/lista/",
            tabla: 42,
            title: "Metodos de Valoración",
            columns: ["clave", "descripcion","clave_pedimento", "actions"],
            options: {
                filterable: ["clave", "descripcion","clave_pedimento"],
                sortable: ["clave", "descripcion","clave_pedimento"],

                headings: {
                    clave: "Clave",
                    descripcion: "Descripción",
                    "clave_pedimento":"Clave Declarada en Pedimento",
                    actions: "Operaciones"
                }
            },
            camposexcel: {
                Clave: "clave",
                Descripción: "descripcion",
                "Clave Declarada en Pedimento":"clave_pedimento"
            },
            encabezadoLayout: {
                clave: "clave",
                descripcion: "descripcion",
                "clave_pedimento":"clave_pedimento"
            },
            camposLayout: [{
                clave: "[Clave de Metodo de Valoración]",
                descripcion: "[Descripción de Metodo de Valoración]",
                "clave_pedimento":"[Clave Declarada en Pedimento]"
            }],
            model: {
                id: 0,
                clave: "",
                descripcion: "",
                clave_pedimento:""
            },
            form: {
                clave: {
                    requiered: true,
                    label: "Clave",
                    value: "",
                    maxlen: 50
                },
                descripcion: {
                    requiered: true,
                    label: "Descripción",
                    value: "",
                    maxlen: 350
                },
                clave_pedimento: {
                    requiered: true,
                    label: "Clave Declarada en Pedimento",
                    value: "",
                    maxlen: 50
                },

            },
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "Utilerías",
                    disabled: true,
                    to: ""
                },
                {
                    text: "Apendices",
                    disabled: true,
                    to: ""
                }
            ]
        }
    })
};
</script>
<style scoped>
    .v-card--material{
    min-height: 750px !important;
    }
</style>
<style scoped>
.VueTables >>> thead th {
  white-space: normal !important;
}

.VueTables >>> tbody td{
  white-space: normal !important;
}
</style>